export default __webpack_public_path__ + "static/media/DOWN-ARROW.b71aad0e.svg";